
import React from "react";
import { Wrapper } from "../../Common/styles.common";
import { Loader } from "../../Common/Loader";
import {
    DDPodFormHeader,
    DDPodFormOtpSection,
    DDPodFormImageUploadSection,
} from "./DDPodFormElements";

export default function DDPodFormMobile({
    po,
    items,
    showLoader,
    tonnage,
    errorMsg,
    otpPage,
    otp,
    setOtp,
    showError,
    openConfirmation,
    imageArray,
    previewImage,
    fileTypeErr,
    errorText,
    navigateToOtpPage,
    makeValidateOtp,
    closeConfirmation,
    handleImageInputChange,
}) {
    return (
        <React.Fragment>
            {showLoader ? (
                <Loader />
            ) : (
                <Wrapper>
                    <DDPodFormHeader po={po} items={items} tonnage={tonnage} />
                    {otpPage ? (
                        <DDPodFormOtpSection
                            otp={otp}
                            setOtp={setOtp}
                            showError={showError}
                            errorText={errorText}
                            makeValidateOtp={makeValidateOtp}
                            openConfirmation={openConfirmation}
                            closeConfirmation={closeConfirmation}
                        />
                    ) : (
                        <DDPodFormImageUploadSection
                            imageArray={imageArray}
                            previewImage={previewImage}
                            handleImageInputChange={handleImageInputChange}
                            errorMsg={errorMsg}
                            fileTypeErr={fileTypeErr}
                            navigateToOtpPage={navigateToOtpPage}
                            uploadTitle="Upload delivery challan"
                        />
                    )}
                </Wrapper>
            )}
        </React.Fragment>
    );
}
